
module.exports = { 
    // 'url' : 'https://staging.byd-mega.com/api/v1/'
    'url' : 'https://byd-mega.com/api/v1/'
    // 'url' : 'http://172.16.10.125:3000/api/v1/' 
    // 'url' : 'https://byd-backend-api.onrender.com/api/v1/'
}



